<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>积分明细信息</span>
    </div>

    <div class="search-bar search-wrap">
      <el-input v-model.trim="query.nickname" placeholder="用户昵称" clearable style="width: 180px" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.phone" placeholder="手机号" clearable style="width: 180px" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.changeType" clearable placeholder="变动类型" style="width: 160px">
        <el-option label="注册赠送" value="register" />
        <el-option label="完善资料" value="profile" />
        <el-option label="签到赠送" value="sign" />
        <el-option label="兑换扣减" value="exchange" />
        <el-option label="退回积分" value="refund" />
        <el-option label="后台派发" value="manual" />
        <el-option label="过期扣减" value="expire" />
        <el-option label="冻结解冻" value="unfreeze" />
      </el-select>
      <el-input v-model.trim="query.bizNo" placeholder="业务单号" clearable style="width: 220px" @keyup.enter.native="handleSearch" />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
      <el-button
        v-if="$hasPermission('mall:member-user:grant-points')"
        type="primary"
        @click="openGrantDialog"
      >
        派发积分
      </el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="changeNo" label="流水号" min-width="180" show-overflow-tooltip />
      <el-table-column prop="nickname" label="用户昵称" width="130" />
      <el-table-column prop="phone" label="手机号" width="130" />
      <el-table-column prop="changeType" label="变动类型" width="110">
        <template slot-scope="{ row }">{{ changeTypeText(row.changeType) }}</template>
      </el-table-column>
      <el-table-column prop="pointType" label="积分类型" width="100">
        <template slot-scope="{ row }">{{ pointTypeText(row.pointType) }}</template>
      </el-table-column>
      <el-table-column prop="changePoints" label="变动积分" width="100" align="right" />
      <el-table-column prop="afterPoints" label="账户余额" width="100" align="right" />
      <el-table-column prop="createTime" label="创建时间" width="170" />
      <el-table-column label="操作" width="90" fixed="right">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" @click="openDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog title="派发积分" :visible.sync="grantVisible" width="560px" :close-on-click-modal="false">
      <el-form ref="grantFormRef" :model="grantForm" :rules="grantRules" label-width="100px">
        <el-form-item label="选择会员" prop="userId">
          <el-select
            v-model="grantForm.userId"
            filterable
            remote
            :reserve-keyword="false"
            clearable
            placeholder="输入用户ID、昵称或手机号搜索"
            :remote-method="loadMemberOptions"
            :loading="memberLoading"
            style="width: 100%"
            @change="handleMemberChange"
            @clear="handleMemberClear"
            @focus="handleMemberFocus"
          >
            <el-option
              v-for="item in memberOptions"
              :key="item.id"
              :label="memberOptionLabel(item)"
              :value="item.id"
            />
          </el-select>
          <div class="form-tip">手机号未绑定时也可以用用户ID或昵称搜索，最终按用户ID派发。</div>
        </el-form-item>
        <el-form-item v-if="selectedMember" label="当前会员">
          <div class="member-preview">
            <el-avatar :src="selectedMember.avatarUrl" :size="40">{{ (selectedMember.nickname || '会').slice(0, 1) }}</el-avatar>
            <div>
              <div class="member-preview__name">{{ selectedMember.nickname || '-' }}</div>
              <div class="member-preview__meta">
                ID: {{ selectedMember.id }} / 手机号: {{ selectedMember.phone || '未绑定手机号' }} / 可用积分: {{ selectedMember.availablePoints || 0 }}
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="积分类型" prop="pointType">
          <el-select v-model="grantForm.pointType" style="width: 100%">
            <el-option label="活动积分（立即可用，默认一年过期）" value="activity" />
            <el-option label="消费积分（冻结10天后可用）" value="consume" />
          </el-select>
        </el-form-item>
        <el-form-item label="派发积分" prop="points">
          <el-input v-model.number="grantForm.points" placeholder="请输入整数，支持负数扣减积分" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="grantForm.remark" type="textarea" :rows="4" maxlength="100" show-word-limit placeholder="请输入派发备注" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="grantVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission('mall:member-user:grant-points')"
          type="primary"
          :loading="grantLoading"
          @click="submitGrant"
        >
          确认派发
        </el-button>
      </span>
    </el-dialog>

    <el-dialog title="积分明细详情" :visible.sync="detailVisible" width="760px">
      <el-descriptions v-if="detail" :column="2" border>
        <el-descriptions-item label="流水号">{{ detail.changeNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detail.userId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="用户昵称">{{ detail.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detail.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="变动类型">{{ changeTypeText(detail.changeType) }}</el-descriptions-item>
        <el-descriptions-item label="积分类型">{{ pointTypeText(detail.pointType) }}</el-descriptions-item>
        <el-descriptions-item label="业务类型">{{ bizTypeText(detail.bizType) }}</el-descriptions-item>
        <el-descriptions-item label="业务单号">{{ detail.bizNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="变动积分">{{ detail.changePoints }}</el-descriptions-item>
        <el-descriptions-item label="账户余额">{{ detail.afterPoints }}</el-descriptions-item>
        <el-descriptions-item label="已用积分">{{ detail.usedPoints }}</el-descriptions-item>
        <el-descriptions-item label="剩余积分">{{ detail.remainPoints }}</el-descriptions-item>
        <el-descriptions-item label="过期扣减">{{ detail.expireDeductPoints }}</el-descriptions-item>
        <el-descriptions-item label="冻结状态">{{ frozenFlagText(detail.frozenFlag) }}</el-descriptions-item>
        <el-descriptions-item label="过期/解冻时间">{{ detail.expireTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detail.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button type="primary" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return { page: 1, limit: 10, nickname: '', phone: '', changeType: '', bizNo: '' }
}

function defaultGrantForm () {
  return { userId: null, pointType: 'activity', points: null, remark: '' }
}

export default {
  data () {
    const validatePoints = (rule, value, callback) => {
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入派发积分'))
        return
      }
      if (!Number.isInteger(value)) {
        callback(new Error('派发积分必须为整数'))
        return
      }
      if (value === 0) {
        callback(new Error('派发积分不能为0'))
        return
      }
      callback()
    }
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      detailVisible: false,
      detail: null,
      grantVisible: false,
      grantLoading: false,
      grantForm: defaultGrantForm(),
      grantRules: {
        userId: [{ required: true, message: '请选择会员', trigger: 'change' }],
        pointType: [{ required: true, message: '请选择积分类型', trigger: 'change' }],
        points: [{ required: true, validator: validatePoints, trigger: 'blur' }],
        remark: [{ required: true, message: '请输入派发备注', trigger: 'blur' }]
      },
      memberLoading: false,
      memberOptions: [],
      memberSearchSeq: 0,
      selectedMember: null
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const { data } = await http.get('/mall/point-detail/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    changeTypeText (value) {
      const map = { register: '注册赠送', profile: '完善资料', sign: '签到赠送', exchange: '兑换扣减', refund: '退回积分', manual: '后台派发', manual_deduct: '后台扣减', expire: '过期扣减', unfreeze: '冻结解冻' }
      return map[value] || value || '-'
    },
    pointTypeText (value) {
      const map = { activity: '活动积分', consume: '消费积分', use: '使用积分' }
      return map[value] || value || '-'
    },
    bizTypeText (value) {
      const map = { user: '用户', order: '订单', after_sale: '售后', point_expire: '积分过期', point_unfreeze: '积分解冻' }
      return map[value] || value || '-'
    },
    frozenFlagText (value) {
      return Number(value) === 1 ? '冻结中' : '正常'
    },
    openDetail (row) {
      this.detail = row ? { ...row } : null
      this.detailVisible = true
    },
    openGrantDialog () {
      this.grantForm = defaultGrantForm()
      this.selectedMember = null
      this.memberOptions = []
      this.grantVisible = true
      this.loadMemberOptions('')
      this.$nextTick(() => this.$refs.grantFormRef && this.$refs.grantFormRef.clearValidate())
    },
    async loadMemberOptions (keyword) {
      const searchSeq = ++this.memberSearchSeq
      this.memberLoading = true
      try {
        const { data } = await http.get('/mall/member-user/options', {
          params: { keyword: keyword || '', limit: 20 }
        })
        const result = data.data || {}
        if (searchSeq === this.memberSearchSeq) {
          this.memberOptions = result.list || []
        }
      } finally {
        if (searchSeq === this.memberSearchSeq) {
          this.memberLoading = false
        }
      }
    },
    handleMemberChange (userId) {
      if (!userId) {
        this.selectedMember = null
        return
      }
      this.selectedMember = this.memberOptions.find(item => String(item.id) === String(userId)) || null
    },
    handleMemberClear () {
      this.grantForm.userId = null
      this.selectedMember = null
      this.loadMemberOptions('')
    },
    handleMemberFocus () {
      if (!this.grantForm.userId && !this.memberOptions.length) {
        this.loadMemberOptions('')
      }
    },
    memberOptionLabel (item) {
      if (!item) return ''
      return `ID:${item.id} / ${item.nickname || '未命名会员'} / ${item.phone || '未绑定手机号'}`
    },
    submitGrant () {
      this.$refs.grantFormRef.validate(async valid => {
        if (!valid) return
        this.grantLoading = true
        try {
          const { data } = await http.post('/mall/member-user/grant-points', {
            userId: this.grantForm.userId,
            pointType: this.grantForm.pointType,
            points: this.grantForm.points,
            remark: this.grantForm.remark
          })
          if (data.code === 0) {
            const actionText = this.grantForm.points > 0 ? '派发' : '扣减'
            this.$message.success(`${this.pointTypeText(this.grantForm.pointType)}${actionText}成功`)
            this.grantVisible = false
            this.load()
          }
        } finally {
          this.grantLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.form-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.member-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #f6f8fb;
  border-radius: 8px;
}

.member-preview__name {
  color: #1f2937;
  font-weight: 600;
}

.member-preview__meta {
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
}
</style>
